import React, { useEffect } from "react";

export default function Home() {
  const coreServices = [
    { id: 1, title: "Speech Therapy", img: "/speech.png" },
    { id: 2, title: "Occupational Therapy", img: "/occupational.png" },
    { id: 3, title: "Physiotherapy", img: "/physio.png" },
    { id: 4, title: "Behavioral Therapy", img: "/behaviour.png" },
    { id: 5, title: "Special Education", img: "/education.png" },
    { id: 6, title: "Psychologist", img: "/psychology.png" },
     { id: 6, title: "Advanced Physio", img: "/advancedPhysio.png" },
  ];

  // Set browser tab title
  useEffect(() => {
    document.title = "Home | Gifted Child Therapy";
  }, []);


  return (
    <div>
      {/* Hero Section */}
      <div className="hero-container">
        <img src="/choose1.png" alt="Cover" className="hero-image" />
        <div className="hero-overlay"></div>
        <div className="hero-text">
          <h1 className="display-3 fw-bold">THE GIFTED CHILD</h1>
          <h2 className="fw-semibold">PEDIATRIC THERAPY CENTER</h2>
          <p className="lead fst-italic">Building skills for better life</p>
        </div>
      </div>

      {/* Welcome Section */}
      <div className="container welcome-section">
        <h3 className="fw-bold section-title mb-4">Welcome</h3>
        <p className="lead welcome-text">
          Welcome to <span className="fw-semibold">The Gifted Child</span> – a
          specialized pediatric therapy centre where every child is uniquely
          gifted. Our team is dedicated to helping children achieve their
          developmental milestones with care, compassion, and expertise.
        </p>
      </div>

      {/* Why Choose Us */}
      <div className="container my-5">
        <h3 className="fw-bold section-title text-center mb-5">Why Choose Us?</h3>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="why-card shadow-sm">
              <img src="/choose1.png" alt="Family Care" className="why-icon mb-3" />
              <h5 className="fw-semibold">Child-Centered Care</h5>
              <p>We provide child-focused and family-inclusive therapy.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="why-card shadow-sm">
              <img src="/choose2.png" alt="Therapists" className="why-icon mb-3" />
              <h5 className="fw-semibold">Qualified Therapists</h5>
              <p>Experienced, certified, and compassionate professionals.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="why-card shadow-sm">
              <img src="/choose3.png" alt="Services" className="why-icon mb-3" />
              <h5 className="fw-semibold">Multi-Disciplinary Services</h5>
              <p>Speech, occupational, physiotherapy & more under one roof.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="why-card shadow-sm">
              <img src="/choose4.png" alt="Education Plan" className="why-icon mb-3" />
              <h5 className="fw-semibold">Individualized Plans</h5>
              <p>Tailored therapy & education plans for every child’s needs.</p>
            </div>
          </div>

          <div className="col-md-4">
            <div className="why-card shadow-sm">
              <img src="/choose5.png" alt="Safety" className="why-icon mb-3" />
              <h5 className="fw-semibold">Safe, Sensory Spaces</h5>
              <p>Child-friendly and adaptive therapy spaces for comfort.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Core Services Horizontal Grid */}
      <div className="container py-5">
        <h3 className="fw-bold section-title text-center mb-4">Our Core Services</h3>
        <div className="core-services-grid">
          {coreServices.map((service) => (
            <div key={service.id} className="service-card">
              <img src={service.img} alt={service.title} className="service-card-img" />
              <h5 className="service-card-title">{service.title}</h5>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
